

<div *ngIf="!showRequest">
    <h2 class="sectionTitle">{{'FRONT_USER.Manager_OFFICER_FORM.MANAGER_OFFICER_FORM' | translate }}</h2>
    <app-measurement-officer-fees-new [isShow]="false" #measurementRequest></app-measurement-officer-fees-new>
    <div *ngIf="baseRequestId" class="">
     <form [formGroup]="managerForm" >
        <div class="form-container">
          <div *ngIf="this.measurementRequest.reviewerdecisionValue == this.measurementRequest.reviewerdecision.Approve" class="form-section">
              <h4 class="section-title">{{'FRONT_USER.Manager_OFFICER_FORM.TOTALFEES'| translate}}</h4>

            <div class="form-group">
                <label for="TotalFees">{{'FRONT_USER.Manager_OFFICER_FORM.TOTAL_FEES' | translate}}</label>
                <span class="red">*</span>
                <input formControlName="TotalFees"  id="TotalFees" name="TotalFees" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted ||(f.TotalFees?.dirty && f.TotalFees?.errors) }"/>
                <div *ngIf="submitted ||(f.TotalFees?.dirty && f.TotalFees?.errors)" class="red">
                  <div *ngIf="f.TotalFees?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="f.TotalFees?.errors?.pattern">
                      {{'FRONT_USER.NUMBER_ERROR' | translate}}
                  </div>
                  <div *ngIf="f.TotalFees?.errors?.startsWithSpaceError">
                    {{'FRONT_USER.START_WITH_SPACE' | translate}}
                  </div>
                </div>
      
              </div>
          </div>
  
          <div *ngIf="formMode == FormMode.Add"class="form-group">
            <button Confirmation  (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.CONFIRM' | translate}}</button>
          </div>
        </div>
      </form>
  
      <br>
  
    </div>
  </div>
  <!-- Confirmation -->
  <div *ngIf="showRequest && !isErrorMessage && !lockTaskErrorMessage" class="alert alert-success" role="alert">
    <div class="alignC">
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g>
          <g>
            <path
              d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
            </path>
          </g>
        </g>
      </svg>
      <p>{{ 'FRONT_USER.Manager_OFFICER_FORM.MANAGER_SUCCESS' | translate }}</p>
      <hr>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace"> {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
   
    </div>
  </div>

  <!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>

        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
      </div>
  </div>